import { computed, input } from '@angular/core';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import { stripContextBlocks } from 'AgentApp/ts/utils/context-block';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
function AgentUserMessageComponent_For_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 4)(2, "div", 5)(3, "div", 6)(4, "div", 7);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(5, "svg", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(6, "div", 9);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const file_r1 = ctx.$implicit;
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(file_r1.fileName);
} }
export class AgentUserMessageComponent {
    constructor() {
        this.messageText = input.required(...(ngDevMode ? [{ debugName: "messageText" }] : []));
        this.displayText = computed(() => stripContextBlocks(this.messageText()), ...(ngDevMode ? [{ debugName: "displayText" }] : []));
        this.files = input([], ...(ngDevMode ? [{ debugName: "files" }] : []));
        this.filesWithFileName = computed(() => {
            const files = this.files();
            return files.map((file) => ({ ...file, fileName: this.getFileName(file) }));
        }, ...(ngDevMode ? [{ debugName: "filesWithFileName" }] : []));
    }
    getFileName(file) {
        return file.attachment_url.split('/').pop() || file.attachment_url;
    }
}
AgentUserMessageComponent.ɵfac = function AgentUserMessageComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AgentUserMessageComponent)(); };
AgentUserMessageComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentUserMessageComponent, selectors: [["ycn-agent-user-message"]], inputs: { messageText: [1, "messageText"], files: [1, "files"] }, decls: 6, vars: 1, consts: [[1, "pl-20", "mt-10"], [1, "plates", "plates-view-list", "mb-1", "text-right"], [1, "plate-container", "d-inline-flex"], [1, "text-large", "leading-aire", "mb-4", "text-prewrap", "text-right"], [1, "plate", "plate-white"], [1, "plate-header", "width-full"], [1, "plate-title", "min-width-0"], [1, "plate-title-icon"], ["ycnIcon", "", "name", "icon-overview"], [1, "plate-title-name", "min-width-0", "text-ellipsis"]], template: function AgentUserMessageComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵrepeaterCreate(2, AgentUserMessageComponent_For_3_Template, 8, 1, "div", 2, i0.ɵɵrepeaterTrackByIndex);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵrepeater(ctx.filesWithFileName());
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.displayText());
    } }, dependencies: [IconModule, i1.IconDirective, TooltipModule], encapsulation: 2, changeDetection: 0 });
